
import { Component, Prop, VModel } from 'vue-property-decorator'
import { Mixins } from 'vue-mixin-decorator'
import MixinInterface from '@/_mixins/index'
import MomentMixin from '@/_mixins/moment'

import { observationIcons } from '@/types/observation'

@Component({ mixins: [MomentMixin], inheritAttrs: false })
export default class DateTimeDropdown extends Mixins<MixinInterface>(MomentMixin) {
    @VModel() val!: string | null
    @Prop({ required: true }) itemType!: 'happenedAt'
    @Prop({ default: false }) disabled!: boolean
    @Prop({ required: false }) timeZone!: string

    get observationIcons() {
        return observationIcons
    }

    get localTimeZone() {
        return this.timeZone ? this.timeZone : this.getDeviceTimeZone
    }

    get dateFormatted() {
        return this.val ? this.formatDate(this.val, this.timeZone, 'YYYY-MM-DD') : null
    }

    set dateFormatted(data) {
        this.val =
            data && this.timeFormatted
                ? this.formatDateTimeWithTimeZone(data, this.timeFormatted, this.timeZone)
                : null
    }

    get timeFormatted() {
        return this.val ? this.formatDate(this.val, this.timeZone, 'HH:mm') : '00:00'
    }

    set timeFormatted(data) {
        this.val =
            data && this.dateFormatted
                ? this.formatDateTimeWithTimeZone(this.dateFormatted, data, this.timeZone)
                : null
    }

    get locale() {
        return this.$i18n.locale
    }
}
